/**
 * Binge Club - Anonymous One-Way Universe Vault Resolver
 * ZERO plaintext trademarked strings or copyrighted character names exist in this file.
 * Evaluates human input in < 0.05ms client-side via irreversible 64-bit hashes.
 */
(function() {
  'use strict';

  function fnv1a64(str) {
    var h1 = 0x811c9dc5;
    var h2 = 0x84222325;
    for (var i = 0; i < str.length; i++) {
      var c = str.charCodeAt(i);
      h1 = Math.imul(h1 ^ c, 0x01000193);
      h2 = Math.imul(h2 ^ (c >> 4), 0x01000193);
    }
    return (h1 >>> 0).toString(16).padStart(8, '0') + (h2 >>> 0).toString(16).padStart(8, '0');
  }

  function normalize(str) {
    return (str || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  var VAULT = {
  "c01023eca1c9d7d6": "scranton-branch",
  "aa8eba31ceb06add": "scranton-branch",
  "49d1db30814e65b1": "scranton-branch",
  "8b9daa2d162b57e4": "scranton-branch",
  "5c2691a8a927e3e1": "scranton-branch",
  "937cd7bc3a7a9cf5": "scranton-branch",
  "50ab043d2f23dede": "scranton-branch",
  "fbbe7c934fa6ac82": "scranton-branch",
  "1ec7d6fdc2a3bb4a": "scranton-branch",
  "52f9917a397a9b62": "scranton-branch",
  "a7df512be1029fff": "scranton-branch",
  "dcd0e8cdde66f24c": "scranton-branch",
  "2bcae4098d0ddb3f": "scranton-branch",
  "d5aa062b3045f862": "scranton-branch",
  "7240cc8c06be9e4e": "scranton-branch",
  "797d8b94842150c1": "scranton-branch",
  "6adb6ab5fd22612e": "scranton-branch",
  "ebf2b08e601aa8dc": "scranton-branch",
  "96bc6d78fa7c4eb9": "scranton-branch",
  "0e94be70095dfa42": "scranton-branch",
  "b1a599f6bbc15d02": "scranton-branch",
  "58ba6745c5dcb42e": "scranton-branch",
  "6fdab6a9a2066e15": "scranton-branch",
  "11c5636494b08d2d": "scranton-branch",
  "8a2be97989216699": "scranton-branch",
  "69c023e5869d9dae": "scranton-branch",
  "27e245c361b7c212": "scranton-branch",
  "76c25a5d49d72849": "scranton-branch",
  "3e358c034c0748e4": "albuquerque-empire",
  "e98280564339350c": "albuquerque-empire",
  "18da47e71e2ddfa3": "albuquerque-empire",
  "ed37b63b84e1a2ec": "albuquerque-empire",
  "235157ab923c75d4": "albuquerque-empire",
  "cd74224ddc652399": "albuquerque-empire",
  "9da178157c9bdb36": "albuquerque-empire",
  "7734489a58378504": "albuquerque-empire",
  "54337f2eeee5345e": "albuquerque-empire",
  "3654035201c4923a": "albuquerque-empire",
  "1c888617b09741a5": "albuquerque-empire",
  "aef0fef9424e65e9": "albuquerque-empire",
  "fb2fff6e3f067f92": "albuquerque-empire",
  "6c1445d13572e2c2": "albuquerque-empire",
  "78d8fd14942c05e6": "albuquerque-empire",
  "0d97c314807a4a91": "albuquerque-empire",
  "ad9b5f4072a93586": "albuquerque-empire",
  "05cc2bd4524db79a": "albuquerque-empire",
  "97527d8bee61277c": "albuquerque-empire",
  "f60f95bee1db042a": "albuquerque-empire",
  "a7a4b2f2fd4a2fcb": "albuquerque-empire",
  "51d57b7602b14707": "albuquerque-empire",
  "f9747611a04f5fe5": "albuquerque-empire",
  "8bdbdcdae1029fff": "90s-sitcom",
  "b491cfe697f9f30b": "90s-sitcom",
  "235921336f9f294d": "90s-sitcom",
  "2419f46f895eb342": "90s-sitcom",
  "ec7ac780f528e55a": "90s-sitcom",
  "65f76b919ae7e00b": "90s-sitcom",
  "24b3d02a84749d8e": "90s-sitcom",
  "d13c1697e705b2e4": "90s-sitcom",
  "8841ff3e6cb25675": "90s-sitcom",
  "418944013750dbee": "90s-sitcom",
  "83c3b4f96775cd98": "90s-sitcom",
  "68d1b76dc9477b2c": "90s-sitcom",
  "fbf05517e52db09a": "90s-sitcom",
  "650a1fa03ff011d6": "90s-sitcom",
  "bf389daed3f78459": "90s-sitcom",
  "a1483424fac286c5": "90s-sitcom",
  "269cd127aeedcc99": "90s-sitcom",
  "98f23c8af5eb7672": "90s-sitcom",
  "a8d270033d420e7b": "90s-sitcom",
  "65d578665c9e3b78": "90s-sitcom",
  "72a9475e1cca2508": "90s-sitcom",
  "af5e680a3ff979d3": "90s-sitcom",
  "bcecf45cce1f822c": "90s-sitcom",
  "f99adadcb7c79144": "dark-vigilante",
  "55d83bcde0fb58fc": "dark-vigilante",
  "d8e464bc55fe92cf": "dark-vigilante",
  "c98c2ddcdfdf6636": "dark-vigilante",
  "c5d32160795a3c13": "dark-vigilante",
  "6de07115b7c79144": "dark-vigilante",
  "80937712760103c6": "dark-vigilante",
  "dab26c96e6252e8f": "dark-vigilante",
  "60d815355d9e3d0b": "dark-vigilante",
  "ebe913f0beb872df": "dark-vigilante",
  "31951ed95a513ab5": "dark-vigilante",
  "2df7b1fc70377fff": "dark-vigilante",
  "10dd5737225a5e6c": "dark-vigilante",
  "4e48734c59378697": "dark-vigilante",
  "449437a7397a9b62": "dark-vigilante",
  "1b05663ce4638975": "dark-vigilante",
  "8e3c2d96c21dc12d": "dark-vigilante",
  "cab53c124c76242c": "dark-vigilante",
  "85373da70b62996b": "dark-vigilante",
  "bb7c5f2cea7f4b90": "dark-vigilante",
  "f163415e56a44e53": "comic-legends",
  "e72bf2ce2f21d368": "comic-legends",
  "3fa2bac9e1029fff": "comic-legends",
  "cea8e51c81129dfe": "comic-legends",
  "b2a558bc1596e33e": "comic-legends",
  "49486bb5e0029e6c": "comic-legends",
  "25076075be84baea": "comic-legends",
  "34401d2ecdec780c": "comic-legends",
  "9bbc78de7c5d9a2d": "comic-legends",
  "d93adb78446862af": "comic-legends",
  "ccf9bb045a513ab5": "comic-legends",
  "d6f7f4d4fd4a2fcb": "comic-legends",
  "d793aa4e66c6cb9a": "comic-legends",
  "c81bcb1488fd7dc4": "comic-legends",
  "d09b1e52249e8340": "comic-legends",
  "cdc469b90b3e5553": "comic-legends",
  "17d1dae83ab836c1": "comic-legends",
  "8d561ed7083a5e9b": "comic-legends",
  "bced4e4c52a40948": "comic-legends",
  "514e052dbb8daf4d": "comic-legends",
  "d464e7e8895eb342": "comic-legends",
  "1b6d0e89665b0aea": "iron-realm",
  "581bb82d81129dfe": "iron-realm",
  "1bd24e4e99de8e93": "iron-realm",
  "be00fa10284ead68": "iron-realm",
  "841a3be3c5f667ba": "iron-realm",
  "c986608171cb7cdc": "iron-realm",
  "3d2fb71752c5e35b": "iron-realm",
  "98eb78e5c629b466": "iron-realm",
  "3d45fb12529c95b3": "iron-realm",
  "2b279baaa923d790": "iron-realm",
  "7bd9e873b312ecdb": "iron-realm",
  "8edd8519e95880c0": "iron-realm",
  "967f54bbed3d4a19": "iron-realm",
  "513c49f9fa6ed3ac": "iron-realm",
  "c04d1e122ba8be9e": "iron-realm",
  "aa75625d73830a96": "iron-realm",
  "eebd6b3cd3a646ea": "iron-realm",
  "5c94ceb08bf9ab63": "iron-realm",
  "078c02db5179563e": "iron-realm",
  "0f50cc852282c1d1": "iron-realm",
  "f319acbeba300ed3": "iron-realm",
  "8d7435469c00af7f": "consulting-detective",
  "e1f266480c290a84": "consulting-detective",
  "d1ed4243cdb0694a": "consulting-detective",
  "5f83905700c8f5d9": "consulting-detective",
  "3d4e3cd8dc44f122": "consulting-detective",
  "15960680f2726255": "consulting-detective",
  "8f171398cfd3232f": "consulting-detective",
  "474395359f06fc2a": "consulting-detective",
  "7c482cba6c849672": "consulting-detective",
  "f2f1c35552a40948": "consulting-detective",
  "3eb11713d60e587f": "consulting-detective",
  "cd436bb443751637": "consulting-detective",
  "e9cfc36ee0767a2f": "consulting-detective",
  "0fa8bda25e836def": "80s-supernatural-mystery",
  "9dfed4909229ac79": "80s-supernatural-mystery",
  "371431c7b5f77eff": "80s-supernatural-mystery",
  "b4f6d7ba0e216c54": "80s-supernatural-mystery",
  "8ff536801fd3949e": "80s-supernatural-mystery",
  "674913103750dbee": "80s-supernatural-mystery",
  "bb558a5e772d7141": "80s-supernatural-mystery",
  "4732144e3f7a5b55": "80s-supernatural-mystery",
  "7ecf4160eb860f68": "80s-supernatural-mystery",
  "a4b6a89214be727f": "80s-supernatural-mystery",
  "61990bd9beef2b2d": "80s-supernatural-mystery",
  "fad460e6e9fb057d": "80s-supernatural-mystery",
  "bdd0e022ca2642a1": "80s-supernatural-mystery",
  "1fab569bd56178f7": "80s-supernatural-mystery",
  "9f4e2bd76be76ad5": "80s-supernatural-mystery",
  "4fd77a7b0bdef3c6": "80s-supernatural-mystery",
  "ef2b7676d63509bf": "galactic-saga",
  "577e45575a513ab5": "galactic-saga",
  "3491e995656ad539": "galactic-saga",
  "de2d50bc5d9e3d0b": "galactic-saga",
  "a6972b433850dd81": "galactic-saga",
  "957ff159c55b707e": "galactic-saga",
  "e56ff7b4f942772b": "galactic-saga",
  "13caa0ba4368611c": "galactic-saga",
  "8f4994c7b186c578": "galactic-saga",
  "7096a70d593a1de3": "galactic-saga",
  "7610659e1a6d9e13": "galactic-saga",
  "2c76c42cf86ea280": "galactic-saga",
  "2c5f5065d9ca0561": "galactic-saga",
  "d3769db245b0aa3e": "galactic-saga",
  "58f3f059e38db711": "galactic-saga",
  "0d181a904feea25a": "galactic-saga",
  "a0dae022c1a81ee9": "galactic-saga",
  "9ad453971fd3949e": "galactic-saga",
  "6b3437b5ceb06add": "galactic-saga",
  "b725938d89fd7f57": "galactic-saga",
  "cfb41b47a1c86bca": "pirate-king",
  "48a92efd593a1de3": "pirate-king",
  "0989fbf288fd7dc4": "pirate-king",
  "fdad54e9656ad539": "pirate-king",
  "4b17db39bbb0dc29": "pirate-king",
  "a6e64d29d0900b4c": "pirate-king",
  "168bc4ae9dc1c711": "pirate-king",
  "9939d0ca5a513ab5": "pirate-king",
  "4869bb4c3750dbee": "pirate-king",
  "dc3ab9f23ecc0e4d": "pirate-king",
  "56872f685fefbff4": "pirate-king",
  "4eb9e872972fe238": "pirate-king",
  "3dc307d2d4a6487d": "pirate-king",
  "c7039781bbdceef3": "pirate-king",
  "1e1e2d285a513ab5": "pirate-king",
  "5a3ce5af13657408": "pirate-king",
  "cad72565be0a9629": "pirate-king",
  "ec81ac05a2c86d5d": "pirate-king",
  "a57c3674a10f29d0": "pirate-king",
  "842c062a4368611c": "pirate-king",
  "a490934fe7dafa8c": "pirate-king",
  "6208bb9834a1da36": "hidden-shinobi",
  "bec6a828fb25c0c0": "hidden-shinobi",
  "0aeefdb7efeeec29": "hidden-shinobi",
  "613c54d185eb1612": "hidden-shinobi",
  "3947511dd9f9449b": "hidden-shinobi",
  "ed8f2683397a9b62": "hidden-shinobi",
  "1bc958c3fdc21f6b": "hidden-shinobi",
  "940738fd3bb3d322": "hidden-shinobi",
  "662fa2880e143b7b": "hidden-shinobi",
  "6782cb2cc1a81ee9": "hidden-shinobi",
  "b021a69fceb06add": "hidden-shinobi",
  "733fcf51250a45ed": "hidden-shinobi",
  "cd28bbc8ceb06add": "hidden-shinobi",
  "ea18c4947b90e104": "hidden-shinobi",
  "2307b566b32c1f03": "hidden-shinobi",
  "35ffede1bedcf3ac": "hidden-shinobi",
  "983af2399caddd90": "hidden-shinobi",
  "b15b4c04b2c149bd": "hidden-shinobi",
  "bce25a2c3735127a": "hidden-shinobi",
  "2a7bf9ffd2253d02": "hidden-shinobi",
  "4f5a6cba7d533418": "breathing-swordsman",
  "4d2047bea8cb566d": "breathing-swordsman",
  "b36cf72d5cb645ac": "breathing-swordsman",
  "9c8092e688c93fb7": "breathing-swordsman",
  "47f5d78de1fb5a8f": "breathing-swordsman",
  "0308b55f56a44e53": "breathing-swordsman",
  "fa57a72344c8bcaf": "breathing-swordsman",
  "97bcf67b60efc187": "breathing-swordsman",
  "3b7d691467c6cd2d": "breathing-swordsman",
  "c1fa04c17cee6548": "breathing-swordsman",
  "7d74927767c6cd2d": "breathing-swordsman",
  "535bd75db32c1f03": "breathing-swordsman",
  "c720c24388216506": "breathing-swordsman",
  "873c64131502a7ec": "breathing-swordsman",
  "b2fe4e1e6485b576": "breathing-swordsman",
  "c43c9c5e20672c3a": "breathing-swordsman",
  "478ee8a56ab66e75": "breathing-swordsman",
  "8483d9b617d05fdb": "breathing-swordsman",
  "12e602bd1b8579b1": "breathing-swordsman",
  "4ec788e249583953": "walled-kingdom",
  "2d2c307781129dfe": "walled-kingdom",
  "6f0d832c8b3410ef": "walled-kingdom",
  "f74e0a2966f28694": "walled-kingdom",
  "71864f9b97b5b39d": "walled-kingdom",
  "b0672450eda757bc": "walled-kingdom",
  "bea668db9caddd90": "walled-kingdom",
  "fc4e084e583a1c50": "walled-kingdom",
  "e38244b16eb876d1": "walled-kingdom",
  "cd8388d18106da82": "walled-kingdom",
  "13db9e386652b346": "walled-kingdom",
  "aa5021d8bf014300": "walled-kingdom",
  "df081eb978c279fb": "walled-kingdom",
  "d251c0605a4000ad": "walled-kingdom",
  "c815a5d99791003b": "walled-kingdom",
  "d735ee7670880a9f": "walled-kingdom",
  "e092ca6cb7787d3d": "walled-kingdom",
  "dcd4030145b0aa3e": "walled-kingdom",
  "f812ad414dab32bb": "underground-society",
  "de9d29d33f9811da": "underground-society",
  "339be09fb21fcdab": "underground-society",
  "edfe20f84fa21bda": "underground-society",
  "e7fca5578c356106": "underground-society",
  "d5c2a80fde6bfc50": "underground-society",
  "81df193072090060": "underground-society",
  "cf87718ce1db042a": "underground-society",
  "506e744ece1c8c8f": "underground-society",
  "6a84bb83159a933d": "underground-society",
  "07040493e0d21699": "underground-society",
  "487da5006d85ddef": "underground-society",
  "a43b953d0543ea3c": "underground-society",
  "134b1ec2d4dd79fe": "underground-society",
  "02530461fbdb6d81": "underground-society",
  "35896ac8368d911c": "underground-society",
  "383f95cba29d51fe": "underground-society",
  "3705c88a35fe39b2": "underground-society",
  "a654e6e7d658f030": "underground-society",
  "afcc8204fd8452b3": "underground-society",
  "66d86c1e86b851cf": "underground-society",
  "660f4ef983ef781e": "underground-society",
  "e90dc728977e855c": "underground-society",
  "2eb9e1245584bdce": "underground-society",
  "053a87ea0d1439e8": "underground-society",
  "5c2e2c082a9e1b1b": "underground-society",
  "f176398a4b4f1c5f": "cursed-buccaneer",
  "9eea59ed656ad539": "cursed-buccaneer",
  "8a81bf694e1fc669": "cursed-buccaneer",
  "2e2284680145df52": "cursed-buccaneer",
  "e35dba2ec56a411d": "cursed-buccaneer",
  "b409154f6c63825e": "cursed-buccaneer",
  "99e01d22175f18c9": "cursed-buccaneer",
  "de67316f2a23c33d": "cursed-buccaneer",
  "2cb6f9fa9f428046": "cursed-buccaneer",
  "7b6261be727adcbb": "cursed-buccaneer",
  "4bfc1d2a438b7cd2": "cursed-buccaneer",
  "6b88b9e4ee645fa4": "cursed-buccaneer",
  "2e53cc9a5a513ab5": "cursed-buccaneer",
  "ff2c79fb4417a2a2": "cursed-buccaneer",
  "289fb66ca3094e9f": "cursed-buccaneer",
  "315566bf0155ec2e": "cursed-buccaneer",
  "e9223bf49110b2ac": "cursed-buccaneer",
  "f6c028e6f17260c2": "cursed-buccaneer",
  "fe1d0fe0b8120623": "cursed-buccaneer",
  "f25ab7c535945a50": "cursed-buccaneer",
  "4039573692d5bcfe": "cursed-buccaneer",
  "06da3d7658378504": "cursed-buccaneer",
  "21e19c1ae6e582ab": "cursed-buccaneer",
  "d0c6d2700f637a16": "cursed-buccaneer",
  "022b0e08b1d6ea8f": "cursed-buccaneer",
  "47590695cd3cc1fc": "cursed-buccaneer",
  "974d0c6eeeb3b062": "cursed-buccaneer",
  "dbbdcda03eed4d6a": "cursed-buccaneer",
  "03fa23e066f28694": "cursed-buccaneer",
  "5a3a093464416768": "cursed-buccaneer",
  "4803878827c110d8": "cursed-buccaneer",
  "37799e50181da87a": "cursed-buccaneer",
  "f1baf5d4b5ceb2de": "cursed-buccaneer",
  "b13ba01a8f2d468d": "cursed-buccaneer",
  "a402e96be1029fff": "cursed-buccaneer",
  "ce20b51b116642bf": "cursed-buccaneer",
  "6c70285c1196ae91": "cursed-buccaneer",
  "99ea1838455040bc": "cursed-buccaneer",
  "7a7291fd00305354": "cursed-buccaneer",
  "7cb5ae075e04581f": "cursed-buccaneer",
  "0dfe0a52224851dc": "cursed-buccaneer",
  "128d563ea3a0179b": "cursed-buccaneer",
  "d2d22a63cc61df21": "cursed-buccaneer",
  "d6029e34beb872df": "cursed-buccaneer",
  "001a2e849b71ae07": "cursed-buccaneer",
  "a00bac8698e95fd1": "cursed-buccaneer",
  "f1edbd9d128a2e7b": "cursed-buccaneer",
  "d7070d795855d327": "cursed-buccaneer",
  "7a1a44d57ddb602d": "cursed-buccaneer",
  "e5d4e5ac4368611c": "cursed-buccaneer",
  "e7135378b52b2673": "cursed-buccaneer",
  "b51832b10d2fef7c": "cursed-buccaneer",
  "bdc220a921e18001": "cursed-buccaneer",
  "12247a627235a486": "cursed-buccaneer",
  "00a0f11adb524bf3": "cursed-buccaneer",
  "dbe1cab3034dc090": "cursed-buccaneer",
  "e339a6880d433df3": "cursed-sorcerers",
  "e6e109fa82129f91": "cursed-sorcerers",
  "8b9ff47b69111450": "cursed-sorcerers",
  "0c40d760c3a3bcdd": "cursed-sorcerers",
  "5d1292e9d4c24b2e": "cursed-sorcerers",
  "e66e08e81ce92377": "cursed-sorcerers",
  "15580d945a513ab5": "cursed-sorcerers",
  "fd5ef260ba46e237": "cursed-sorcerers",
  "12b85f5804380bf4": "cursed-sorcerers",
  "9a9201e65b1da4a2": "cursed-sorcerers",
  "b6213ed702051289": "cursed-sorcerers",
  "98e849de019e5f87": "cursed-sorcerers",
  "f4615356e2451e2b": "cursed-sorcerers",
  "172103011817a004": "cursed-sorcerers",
  "e69e845d1fd3949e": "cursed-sorcerers",
  "957d149efdfc7cee": "cursed-sorcerers",
  "ef541b6e9caddd90": "cursed-sorcerers",
  "8f02a1de785a3a80": "cursed-sorcerers",
  "a55ac357ceb06add": "cursed-sorcerers",
  "86304fdd48bad35a": "cursed-sorcerers",
  "307b96994368611c": "cursed-sorcerers",
  "da546de04c9a6f71": "cursed-sorcerers",
  "d0358e0cc042aa0e": "cursed-sorcerers",
  "c294b77500118783": "cursed-sorcerers",
  "87eb3d28284ead68": "cursed-sorcerers",
  "660d40e99caddd90": "cursed-sorcerers",
  "637c71266f9acc1e": "cursed-sorcerers",
  "7cd3e247409dc3a9": "cursed-sorcerers",
  "90b157ba57a6ab0c": "cursed-sorcerers",
  "41f2b31149a79467": "cursed-sorcerers",
  "0fa5beb6f307b8a0": "cursed-sorcerers",
  "b2b0ec1cb0a08b22": "cursed-sorcerers",
  "0895912f9f24c49c": "cursed-sorcerers",
  "87a08de144d16e39": "cursed-sorcerers",
  "f48228954e1fc669": "cursed-sorcerers",
  "f743c0a89bc9271f": "cursed-sorcerers",
  "c71011c7290407f9": "cursed-sorcerers",
  "d3b79f0e504af7c4": "cursed-sorcerers",
  "5dbf6f409daddf23": "flight-of-the-court",
  "c95c106f5cb645ac": "flight-of-the-court",
  "393d965bee38e67a": "flight-of-the-court",
  "dc3b1a08ceb06add": "flight-of-the-court",
  "3c645204762d6fae": "flight-of-the-court",
  "79aab6e90a2da353": "flight-of-the-court",
  "14b1cbdd0ff184dc": "flight-of-the-court",
  "9d27996d916a8bbd": "flight-of-the-court",
  "a2805be5ed3d4a19": "flight-of-the-court",
  "dcd89d789caddd90": "flight-of-the-court",
  "a13b8242479d7ab6": "flight-of-the-court",
  "9ce678c5201561ac": "flight-of-the-court",
  "8a0c80326e2e4f27": "flight-of-the-court",
  "93815a399caddd90": "flight-of-the-court",
  "e41be4c990a19bd7": "flight-of-the-court",
  "fb22520d292ada5d": "flight-of-the-court",
  "b5c9147341d608bb": "flight-of-the-court",
  "8ca88dab0716f28f": "flight-of-the-court",
  "7eb01b77e0df67c9": "flight-of-the-court",
  "6c7df1ff2348536f": "flight-of-the-court",
  "fa23aa03fc4a2e38": "flight-of-the-court",
  "f34837e5155ccb9b": "flight-of-the-court",
  "8f91871a9129aae6": "flight-of-the-court",
  "3144315b1502a7ec": "flight-of-the-court",
  "d71509c2f3adc1ad": "flight-of-the-court",
  "e607899b9620fad8": "flight-of-the-court",
  "775c8010dbfaa422": "flight-of-the-court",
  "e9aa589dad2d929a": "flight-of-the-court",
  "5d730b3f369d05c7": "flight-of-the-court",
  "af3820d35953500b": "flight-of-the-court",
  "c21e9b6a3750dbee": "flight-of-the-court",
  "18d4f87aa2094d0c": "flight-of-the-court"
};

  window.BingeUniverseResolver = {
    /**
     * Resolves human query to a universe collection handle without exposing any plaintext keywords to bots.
     * Checks exact query, normalized full string, and sliding n-grams (up to 3 words).
     * @param {string} query
     * @returns {string|null} Matched collection handle (e.g. 'scranton-branch') or null
     */
    match: function(query) {
      if (!query || typeof query !== 'string') return null;
      var clean = query.toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
      if (!clean) return null;

      // 1. Direct full string check
      var directHash = fnv1a64(normalize(clean));
      if (VAULT[directHash]) return VAULT[directHash];

      // 2. Sliding window n-grams (3-word, 2-word, 1-word)
      var words = clean.split(' ').filter(Boolean);
      var maxN = Math.min(words.length, 3);

      for (var n = maxN; n >= 1; n--) {
        for (var i = 0; i <= words.length - n; i++) {
          var segment = words.slice(i, i + n).join('');
          var segHash = fnv1a64(segment);
          if (VAULT[segHash]) return VAULT[segHash];
        }
      }
      return null;
    }
  };
})();
